<div class="col-md-12 action-buttons text-right reset-button">
    <div class="reset-input">
        <div class="reset-msg">{{l("ResettingThePasswordWillSendAnEmailToTheUserToCreateANewPassword")}}</div>
        <button style="width: 50%" [buttonBusy]="renderingPasswordReset" [disabled]="disablePasswordResetButton" (click)="resetPassword()" class="btn btn-primary">{{l(actionButtonStructure.componentSettings.actionButtonLabelKey)}}</button>
    </div>
</div>